import React from 'react';
import { OrnamentDivider } from './SectionDivider';
import { CTAButton } from './CTAButton';
export function RevelationSection() {
  return <section className="w-full py-20 px-6 pt-[30px] pb-[30px]" style={{
    background: 'var(--cream)'
  }} aria-label="La revelación" data-id="element-439">
      <div className="max-w-3xl mx-auto" data-id="element-440">
        {/* Section header */}
        <div className="text-center mb-14" data-id="element-441">
          <p className="text-sm font-bold tracking-widest uppercase mb-4" style={{
          color: 'var(--gold-dark)'
        }} data-id="element-442">
            El Cambio de Perspectiva
          </p>
          <h2 className="text-3xl md:text-4xl font-bold leading-tight" style={{
          color: 'var(--brown)'
        }} data-id="element-443">
            ¿Qué pasaría si el problema nunca fue lo que quitaste, sino no saber
            qué poner en su lugar?
          </h2>
        </div>

        <div className="flex flex-col gap-6" data-id="element-444">
          <p className="text-lg leading-relaxed" style={{
          color: 'var(--brown-light)',
          lineHeight: '1.9'
        }} data-id="element-445">
            Hace algunos años, después de ver a mi sobrina llorar en su propio
            cumpleaños porque no podía comer el pastel, me hice una sola
            pregunta:
          </p>

          {/* The question */}
          <div className="text-center py-6" data-id="element-446">
            <p className="text-2xl italic" style={{
            color: 'var(--brown)',
            fontFamily: 'Cormorant Garamond, serif',
            fontSize: '1.6rem'
          }} data-id="element-447">
              ¿Por qué los postres sin gluten siempre quedan mal?
            </p>
          </div>

          <p className="text-lg leading-relaxed" style={{
          color: 'var(--brown-light)',
          lineHeight: '1.9'
        }} data-id="element-448">
            Pasé dos años buscando la respuesta. Probé más de 400 recetas. Tiré
            ingredientes por valor de miles de pesos. Rompí tres moldes en
            ataques de frustración completamente legítima.
          </p>
          <p className="text-lg leading-relaxed" style={{
          color: 'var(--brown-light)',
          lineHeight: '1.9'
        }} data-id="element-449">
            Pero también descubrí algo que ningún libro de cocina saludable
            estaba enseñando:
          </p>

          {/* The revelation */}
          <div className="rounded-2xl p-10 my-4 text-center" style={{
          background: 'linear-gradient(135deg, var(--brown) 0%, #5C3D2E 100%)'
        }} data-id="element-450">
            <div className="quote-mark mb-2" data-id="element-451">"</div>
            <p className="text-2xl font-bold leading-relaxed" style={{
            color: 'var(--gold-light)',
            fontFamily: 'Playfair Display, serif'
          }} data-id="element-452">
              No se trata de eliminar ingredientes.
              <br data-id="element-453" />
              Se trata de reemplazar funciones.
            </p>
          </div>

          <p className="text-lg leading-relaxed" style={{
          color: 'var(--brown-light)',
          lineHeight: '1.9'
        }} data-id="element-454">
            Cuando dejas de preguntarte{' '}
            <em data-id="element-455">"¿cómo hago un postre SIN gluten?"</em> y empiezas a preguntarte{' '}
            <em data-id="element-456">
              "¿cómo replico la FUNCIÓN del gluten con ingredientes que no dañen
              a nadie?"
            </em>
            , los resultados son completamente diferentes.
          </p>

          {/* Method name */}
          <div className="rounded-2xl p-8 text-center" style={{
          background: 'var(--cream-dark)',
          border: '2px solid var(--gold-light)'
        }} data-id="element-457">
            <p className="text-sm font-bold tracking-widest uppercase mb-3" style={{
            color: 'var(--gold-dark)'
          }} data-id="element-458">
              A ese sistema lo llamé
            </p>
            <h3 className="text-4xl font-bold mb-4" style={{
            color: 'var(--brown)',
            fontFamily: 'Playfair Display, serif'
          }} data-id="element-459">
              Método Repostería Zero
            </h3>
            <p className="text-base leading-relaxed" style={{
            color: 'var(--brown-light)'
          }} data-id="element-460">
              Construido desde cero para la realidad latinoamericana. Con lo que
              encuentras en el Walmart de México. En el Éxito de Colombia. En el
              Jumbo de Argentina o Chile. En el Wong de Perú.
            </p>
            <p className="mt-3 font-bold" style={{
            color: 'var(--sage)'
          }} data-id="element-461">
              Sin importaciones. Sin gastos innecesarios. Sin ingredientes
              imposibles de conseguir.
            </p>
          </div>
        </div>

        <OrnamentDivider className="mt-12" data-id="element-462" />

        <div className="mt-8 flex justify-center" data-id="element-463">
          <CTAButton text="QUIERO CONOCER EL MÉTODO" subtext="Acceso inmediato" size="md" scrollTo="precio" data-id="element-464" />
        </div>
      </div>
    </section>;
}